import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';

import { formContextReducer } from './form-context-slice';
import { formDescReducer } from './form-desc-slice';
import { requestsReducer } from './requests-slice';

export const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  reducer: {
    formContext: formContextReducer,
    formDesc: formDescReducer,
    requests: requestsReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
